import { api } from './api';
import { resolveThankYouScene, paintThankYouScene, THANK_YOU_TEMPLATE } from './thankYouTemplateV1.mjs';

// Only validated binary faces reach Canvas. All resources remain owner-private.
export async function renderThankYouPng(input, preflight, premiumPainter = null) {
  if (!window.FontFace || !document.fonts || !HTMLCanvasElement.prototype.toBlob)
    throw new Error('Для PNG нужен актуальный браузер с поддержкой шрифтов и Canvas.');
  const faces = [], families = {};
  let bitmap, symbol, premiumBitmap, sourceBitmap;
  try {
    for (const entry of preflight.fonts) {
      const bytes = Uint8Array.from(atob(entry.data), c=>c.charCodeAt(0));
      const digest = new Uint8Array(await crypto.subtle.digest('SHA-256',bytes));
      const actual = Array.from(digest,b=>b.toString(16).padStart(2,'0')).join('');
      if (actual !== entry.sha256) throw new Error('Файл шрифта изменился. Повтори подготовку.');
      const family = `AP1_${entry.role}_${actual.slice(0,16)}_${entry.weight}_${entry.style}`;
      const face = new FontFace(family,bytes,{weight:String(entry.weight),style:entry.style});
      await face.load();
      if (face.status !== 'loaded') throw new Error('Не удалось загрузить выбранный шрифт.');
      document.fonts.add(face); faces.push(face); families[entry.role]=family;
    }
    if (input.board.logo?.mode === 'existing') {
      const url = input.board.logo.image_url;
      if (!/^\/api\/media\/files\/[A-Za-z0-9_-]+$/.test(url || '')) throw new Error('Приватный логотип недоступен.');
      const response = await api.get(url.replace(/^\/api/,''),{responseType:'blob'});
      if (!['image/png','image/jpeg','image/webp'].includes(response.data.type)) throw new Error('Формат логотипа не поддерживается.');
      if (!window.createImageBitmap) throw new Error('Этот браузер не поддерживает безопасную подготовку логотипа.');
      bitmap = await createImageBitmap(response.data);
    }
    if(input.design?.symbol){
      const response=await fetch('/brand/anokina-studio-sign-master.png');
      if(!response.ok || !window.createImageBitmap)throw new Error('Не удалось открыть фирменный знак.');
      symbol=await createImageBitmap(await response.blob());
    }
    if(premiumPainter){
      if(!input.sceneBlob || input.sceneBlob.type !== 'image/png')throw new Error('Упаковочная сцена недоступна.');
      premiumBitmap=await createImageBitmap(input.sceneBlob);
      if(!input.sourceBlob || input.sourceBlob.type !== 'image/png')throw new Error('Фото продукта недоступно.');
      sourceBitmap=await createImageBitmap(input.sourceBlob);
    }
    const canvas=document.createElement('canvas');
    canvas.width=THANK_YOU_TEMPLATE.width; canvas.height=THANK_YOU_TEMPLATE.height;
    const ctx=canvas.getContext('2d',{colorSpace:'srgb'});
    if (!ctx || (ctx.getContextAttributes?.().colorSpace && ctx.getContextAttributes().colorSpace !== 'srgb')) throw new Error('Не удалось подготовить цифровой PNG.');
    const paintInput={...input,families,logoImage:bitmap,symbolImage:symbol,sceneImage:premiumBitmap,sourceImage:sourceBitmap};
    const scene=premiumPainter?premiumPainter(ctx,paintInput):resolveThankYouScene(ctx,paintInput);
    if(!premiumPainter)paintThankYouScene(ctx,scene);
    const blob=await new Promise((resolve,reject)=>canvas.toBlob(value=>value?resolve(value):reject(new Error('PNG не создан.')),'image/png'));
    if (blob.type !== 'image/png') throw new Error('Браузер не создал корректный PNG.');
    return {blob,scene,binding:preflight.binding,fontChecksums:Object.fromEntries(preflight.fonts.map(f=>[f.role,f.sha256]))};
  } finally { faces.forEach(face=>document.fonts.delete(face)); bitmap?.close(); symbol?.close(); premiumBitmap?.close(); sourceBitmap?.close(); }
}
